<script>
    let cities = [];
    let counties = [];

    getCities(response => {
        cities = response;
    });

    getCounties(response => {
        counties = response;
    });

    let notes = [
        {label: '#', description: 'Uncoordinated system'},
        {label: 'o', description: 'Open system'},
        {label: 'BI', description: 'Bilingual system'},
        {label: 'c', description: 'Closed, limited access system'},
        {label: 'LiTZ', description: 'Long-Tone Zero'},
        {label: 't', description: 'Tone-access (CTCSS) required'},
        {label: 'TT', description: 'Touch-Tone access for features'},
        {label: 'RB', description: 'Remote base'},
        {label: 'a', description: 'Autopatch'},
        {label: '(CA)', description: 'Closed autopatch'},
        {label: 'e', description: 'Emergency power'},
        {label: 'E-SUN', description: 'Solar power'},
        {label: 'E-WIND', description: 'Wind power'},
        {label: 'l', description: 'Linked or crossband system'},
        {label: 'p', description: 'Portable system'},
        {label: 'PKT', description: 'Digital/packet capability'},
        {label: 'r', description: 'RACES affiliated'},
        {label: 's', description: 'ARES affiliated'},
        {label: 'x', description: 'Wide area coverage system'},
        {label: 'y', description: 'RTTY/ASCII system'},
        {label: 'z', description: 'Direct access to law enforcement'},
        {label: 'WX', description: 'Weather net/weather usage'},
        {label: 'EXP', description: 'Experimental system'},
        {label: 'SNP', description: 'Shared non-protected pair'},
    ];

    let repeaters = [];
    let transmit = null, city = null, county = null, callsign = null;

    function submitHandler() {
        document.activeElement.blur();
    }

    function clear() {
        transmit = null;
        city = null;
        county = null;
        callsign = null
    }

    function isClear() {
        return transmit === null && city === null && county === null && callsign === null;
    }

    $: if (transmit || city || county || callsign) {
        search(transmit, city, county, callsign, response => {
            repeaters = response;
        });
    } else {
        repeaters = [];
    }

    function search(transmit, city, county, callsign, cb = () => {
    }) {
        const http = new XMLHttpRequest();
        let url = "repeaters.php?";
        url += transmit ? `transmit=${transmit}&` : '';
        url += city ? `city=${city}&` : '';
        url += county ? `county=${county}&` : '';
        url += callsign ? `callsign=${callsign}&` : '';

        http.open("GET", url);

        http.onreadystatechange = e => {
            if (http.responseText) {
                cb(JSON.parse(http.responseText));
            }
        };

        http.send();
    }

    function getCities(cb = () => {
    }) {
        const http = new XMLHttpRequest();
        let url = "cities.php";

        http.open("GET", url);

        http.onreadystatechange = e => {
            if (http.responseText) {
                cb(JSON.parse(http.responseText));
            }
        };

        http.send();
    }

    function getCounties(cb = () => {
    }) {
        const http = new XMLHttpRequest();
        let url = "counties.php";

        http.open("GET", url);

        http.onreadystatechange = e => {
            if (http.responseText) {
                cb(JSON.parse(http.responseText));
            }
        };

        http.send();
    }

</script>

<style>
    small {
        font-size: .5em;
    }

    .center {
        text-align: center;
    }

    .clear {
        color: #666;
        cursor: pointer;
    }

    .hidden {
        visibility: hidden;
    }

    div.container {
        max-width: 800px;
    }

    form {
        max-width: 500px;
        margin: 0 auto 0 auto;
    }

    label {
        font-weight: bold;
        float: right;
    }

    table {
        max-width: 1000px;
        margin: 0 auto 0 auto;
    }
</style>

<div class="center">
    <h1>Texas Repeater Search</h1>
    <p>Powered by RF Projector</p>
</div>

<form on:submit|preventDefault="{submitHandler}">
    <div class="container">
        <div class="row">
            <div class="col-sm-5">
                <label for="transmit">Output:</label>
            </div>
            <div class="col-sm-7">
                <input type="text" id="transmit" placeholder="147.080" bind:value="{transmit}"/>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5">
                <label for="city">City:</label>
            </div>
            <div class="col-sm-7">
                <select id="city" bind:value="{city}">
                    <option value={null}>Choose...</option>
                    {#each cities as city }
                        <option>{city}</option>
                    {/each}
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5">
                <label for="county">County:</label>
            </div>
            <div class="col-sm-7">
                <select id="county" bind:value="{county}">
                    <option value={null}>Choose...</option>
                    {#each counties as county }
                        <option>{county}</option>
                    {/each}
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5">
                <label for="callsign">Callsign:</label>
            </div>
            <div class="col-sm-7">
                <input type="text" id="callsign" placeholder="" bind:value="{callsign}"/>
            </div>
        </div>
    </div>
    <input type="submit" class="hidden"/>
</form>

<br/>

{#if !isClear() }
    <div class="center">
        <span on:click="{clear}" class="clear">Clear</span>
    </div>

    <br/>
{/if}

{#if repeaters.length }
    <table class="striped" id="results">
        <thead>
        <tr>
            <th>Output</th>
            <th>City</th>
            <th>County</th>
            <th>Callsign</th>
            <th>Notes</th>
            <th>Zone</th>
        </tr>
        </thead>
        <tbody>
        {#each repeaters as {transmit, receive, city, county, callsign, list, zone}}
            <tr>
                <td data-label="Output">{transmit} <span class="hidden">Input: {receive}</span></td>
                <td data-label="City">{city}</td>
                <td data-label="County">{county}</td>
                <td data-label="Callsign">{callsign}</td>
                <td data-label="Notes">{list}</td>
                <td data-label="Zone">{zone}</td>
            </tr>
        {/each}
        </tbody>
    </table>

    <br/>

    <div class="center">
        <span on:click="{clear}" class="clear">Clear</span>
    </div>
{/if}

<div class="center">
    <h3>Notes Legend</h3>
</div>

<div class="container">
    <div class="row">
        {#each notes as note }
            <div class="col-sm-2" style="text-align: right;"><strong>{note.label}</strong></div>
            <div class="col-sm-4">{note.description}</div>
        {/each}
    </div>
</div>

<br/>
<br/>

<div class="center">
    <p>
        &copy; 2019 RF Projector
        <br/>
        For personal use only.
    </p>
    <p>
        Data obtained by this search function may not be republished without permission.
        <br/>
        Contact security&#64;rfprojector.com for more information.
    </p>
</div>